import {Handle, Position} from "react-flow-renderer";

import HintedHandleLabel from "./HintedHandleLabel";
import {useLocalization} from "../../../../../../customHooks/useContextLocalization";


export default function ({data: {label, inputs=[], outputs=[]}}) {
    const locale = useLocalization();

    const inputHandles = [];
    for (let i = 0; i < inputs.length; i++) {
        inputHandles.push(<Handle
            type="target"
            id={`${i}`}
            key={`${i}`}
            position={Position.Left}
            style={{top: `calc(${(i - inputs.length / 2 + 0.5) * 10}px + 50%)`}}
        />);
    }

    const inputLabels = [];
    for (let i = 0; i < inputs.length; i++) {
        const clear_data_type = inputs[i].data_type.startsWith("List")
            ? inputs[i].data_type.replace("List[", "").replace("]", "")
            : inputs[i].data_type;
        inputLabels.push(<HintedHandleLabel
            key={`${i}`}
            name={`${inputs[i].data_type}${inputs[i].role ? ` (${inputs[i].role})` : ""}`}
            tooltipContent={locale.get.project.dfd.nodeTypeHint[clear_data_type]}
            tooltipStyle={{top: `calc(${(i - inputs.length / 2 + 0.5) * 10 - 8}px + 50%)`, left: 5, display: "flex", position: "absolute"}}
        />);
    }

    const outputHandles = [];
    for (let i = 0; i < outputs.length; i++) {
        outputHandles.push(<Handle
            type="source"
            id={`${i}`}
            key={`${i}`}
            position={Position.Right}
            style={{top: `calc(${(i - outputs.length / 2 + 0.5) * 10}px + 50%)`}}
        />);
    }

    const outputLabels = [];
    for (let i = 0; i < outputs.length; i++) {
        const clear_data_type = outputs[i].data_type.startsWith("List")
            ? outputs[i].data_type.replace("List[", "").replace("]", "")
            : outputs[i].data_type;
        outputLabels.push(<HintedHandleLabel
            key={`${i}`}
            name={`${outputs[i].data_type}${outputs[i].role ? ` (${outputs[i].role})` : ""}`}
            style={{right: "100%"}}
            tooltipContent={locale.get.project.dfd.nodeTypeHint[clear_data_type]}
            tooltipStyle={{top: `calc(${(i - outputs.length / 2 + 0.5) * 10 - 8}px + 50%)`, right: 5, position: "absolute"}}
        />);
    }

    return <div className="project-dfd-intermediate-node">
        {inputHandles}
        {inputLabels}
        <label className="project-dfd-intermediate-node-title" htmlFor="text">{label}</label>
        {outputHandles}
        {outputLabels}
    </div>;
};